import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { queryClient } from '@metto/http-clients/api';
import { QueryClientProvider } from '@metto/http-clients/react-query';
import { ErrorLoggerProvider } from '@metto/ui-web/lib/errors';
import { useAppStore, useComponentStore } from '@metto/ui-web/shared/hooks';
import { AddButton } from '~/components';
import Router from './router';

useAppStore.getState().setAppId('web');
useComponentStore.setState({ AddButton });

const App = () => {
  return (
    <ErrorLoggerProvider>
      <MantineProvider classNamesPrefix="metto">
        <Notifications position="top-right" />
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <Router />
          </ModalsProvider>
        </QueryClientProvider>
      </MantineProvider>
    </ErrorLoggerProvider>
  );
};

export default App;
